import { render, staticRenderFns } from "./AgenciaHistoricoSimpleTable.vue?vue&type=template&id=2e9417fc&scoped=true"
import script from "./AgenciaHistoricoSimpleTable.vue?vue&type=script&lang=js"
export * from "./AgenciaHistoricoSimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9417fc",
  null
  
)

export default component.exports